import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
      return (_openBlock(), _createBlock(_component_el_tag, {
        key: tag,
        class: "mx-1",
        closable: "",
        "disable-transitions": false,
        onClose: ($event: any) => (_ctx.onBtnCloseClicked(tag))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(tag), 1)
        ]),
        _: 2
      }, 1032, ["onClose"]))
    }), 128)),
    (_ctx.inputVisible)
      ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          ref: "InputRef",
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
          size: "small",
          style: {"width":"100px"},
          onKeyup: _withKeys(_ctx.onInputAddTagConfirmed, ["enter"]),
          onBlur: _ctx.onInputAddTagConfirmed
        }, null, 8, ["modelValue", "onKeyup", "onBlur"]))
      : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "button-new-tag ml-1",
          size: "small",
          style: {"width":"100px"},
          onClick: _ctx.onBtnAddTagClicked
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + " + _toDisplayString(_ctx.t("tag.New")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
  ], 64))
}